import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';

import { verificarMaioridadePorData, toastApiError } from '../../../../utils/validacoes.js';
import ContratanteForm, { getPayloadTratado } from './formulario.js';

import classNames from 'classnames';
import { useInfo } from '../../../../context/infoContext.js';
import { ApiAdimplencia } from '../../../../services/api.js';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { unMask } from 'remask';

/**
 * Retorna true quando o documento atual é CPF (11 dígitos).
 *
 * @param {string} maskedDoc
 * @returns {boolean}
 */
function isCpfDocumento(maskedDoc) {
  return unMask(maskedDoc || '').length === 11;
}

export default function ContratanteCadastrar({ close, reload }) {
  const { darkMode, credorData } = useInfo();
  const [loading, setLoading] = useState(false);
  const [isLoading] = useState(false);
  const [confirmarCadastrar, setConfirmarCadastrar] = useState(false);
  const [gruposOptions, setGruposOptions] = useState([]);

  const loadGrupos = async () => {
    if (!credorData?.credor_id) return;
    try {
      const { data } = await ApiAdimplencia.get('/credorgrupo/buscar');
      const lista = Array.isArray(data) ? data : (data?.dados || data) || [];
      const sorted = [...lista].sort((a, b) =>
        (a.grupo_descricao || '').localeCompare(b.grupo_descricao || '', 'pt-BR')
      );
      setGruposOptions(
        sorted.map((g) => ({ label: g.grupo_descricao, value: g.credor_grupo_id }))
      );
    } catch {
      setGruposOptions([]);
    }
  };

  useEffect(() => {
    loadGrupos();
  }, [credorData?.credor_id]);

  const [contratanteData, setContratanteData] = useState({
    usuario_nome: '',
    usuario_documento: '',
    usuario_data_nascimento: null,
    contratante_email: '',
    contratante_telefone: '',
    beneficiario: '',
    endereco_rua: '',
    endereco_numero: '',
    endereco_complemento: '',
    endereco_bairro: '',
    endereco_cidade: '',
    endereco_estado: '',
    endereco_cep: '',
    contratante_numero: '',
    credor_grupo_id: null
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Data SEMPRE obrigatória (CPF e CNPJ)
    if (!contratanteData.usuario_data_nascimento) {
      toast.error('Informe a data de nascimento/criação.');
      return;
    }

    // Verificação de maioridade somente para CPF
    const isCpf = isCpfDocumento(contratanteData.usuario_documento);
    if (isCpf && !verificarMaioridadePorData(contratanteData.usuario_data_nascimento)) {
      toast.error('O devedor deve ser maior de idade.');
      return;
    }

    setConfirmarCadastrar(true);
  };

  const cadastrarContratante = async () => {
    setLoading(true);
    try {
      const payload = getPayloadTratado(contratanteData);

      await ApiAdimplencia.post('contratante', payload);
      setConfirmarCadastrar(false);
      toast.success('Cliente cadastrado com sucesso.');
      close();
      reload();
    } catch (err) {
      toastApiError(err, 'Houve um erro ao cadastrar o cliente.');
    } finally {
      setLoading(false);
    }
  };

  const footerDialog = (
    <div className="ml-2 flex justify-content-between">
      <div className="">
        <Button
          severity="info"
          label="Sim"
          icon={<FaCheck />}
          loading={loading}
          onClick={cadastrarContratante}
        />
      </div>
      <div className="">
        <Button
          severity="danger"
          label="Não"
          icon={<FaTimes />}
          loading={loading}
          onClick={() => setConfirmarCadastrar(false)}
        />
      </div>
    </div>
  );

  return (
    <>
      {isLoading && (
        <Dialog visible closable={false} style={{ width: '20vw', maxHeight: '40vh' }} className="Progress-Spinner-Custom" onHide="">
          <ProgressSpinner strokeWidth='3' />
          <p>Aguarde</p>
        </Dialog>
      )}
      {confirmarCadastrar && (
        <Dialog
          header="Deseja cadastrar o cliente?"
          onHide={() => setConfirmarCadastrar(false)}
          footer={footerDialog}
          style={{ width: '20vw', maxHeight: '40vh' }}
          visible
        />
      )}
      <Dialog
        header="Cadastrar Cliente"
        onHide={close}
        visible
        pt={{
          root: 'w-screen md:w-[70vw] max-h-[100vh]',
          header: classNames(
            'flex items-center justify-between shrink-0',
            'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
            'dark:bg-gray-900  dark:text-white/80'
          ),
          content: ({ state }) => ({
            className: classNames(
              'overflow-auto w-full max-h-[85vh]',
              'bg-white text-gray-700 px-6 pb-8 pt-0',
              'rounded-bl-lg rounded-br-lg',
              'dark:bg-gray-900 dark:text-white/80 ',
              { "grow": state.maximized }
            )
          }),
        }}
      >
        <div className="w-full">
          <ContratanteForm
            formData={contratanteData}
            setFormData={setContratanteData}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            darkMode={darkMode}
            isEditMode={false}
            gruposOptions={gruposOptions}
            loadGrupos={loadGrupos}
          />
        </div>
      </Dialog>
    </>
  );
}
